import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Box, Button, CircularProgress } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { useTranslation } from '../../../app/LanguageContext';
import { getConsignmentSettings } from './consignmentApi';

function ConsignmentSettingsGuard({ children }) {
  const { translate } = useTranslation();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [configured, setConfigured] = useState(false);

  useEffect(() => {
    getConsignmentSettings()
      .then((resp) => {
        const orderTypeId = resp?.data?.order_type_id;
        setConfigured(!!orderTypeId);
      })
      .catch(() => {
        setConfigured(false);
      })
      .finally(() => {
        setChecking(false);
      });
  }, []);

  if (checking) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" p={6}>
        <CircularProgress />
      </Box>
    );
  }

  if (!configured) {
    return (
      <Box p={3}>
        <Alert
          severity="warning"
          action={
            <Button
              color="inherit"
              size="small"
              startIcon={<SettingsIcon />}
              onClick={() => navigate('/consignments/settings')}
            >
              {translate('consignment.settings_not_configured_action')}
            </Button>
          }
        >
          <strong>{translate('consignment.settings_not_configured_title')}</strong>
          <br />
          {translate('consignment.settings_not_configured_description')}
        </Alert>
      </Box>
    );
  }

  return children;
}

export default ConsignmentSettingsGuard;
